import { reducer as storeReducer } from 'store/common';
import ActionType from './actionType';

const initialState = {
  company: { id: null, isEdpCompany: false, name: null, ratio: 0 },
  project: null,
};

const setCompany = (state, payload) => ({
  ...state,
  company: payload.company,
  project: payload.project,
});

const actionsMapping = {
  [ActionType.SET_COMPANY]: setCompany,
};

const reducer = (state = initialState, action) => storeReducer(actionsMapping, state, action);

export default reducer;
